import {noop} from '@priority-software/priority-style-react';
import {fetchDateChoosesOld} from '../../../../../../modules/BPMRules/api/bpmChooseSearch';
import {fetchDateChooses as fetchDateChoosesNewAPI} from '../../../../../../actions';

export const fetchDateChooses = async (
    session: string,
    columnID: number,
    oldAPI: boolean,
    onCriticalError: () => void = noop
): Promise<
    {
        label: string;
        value: string;
    }[]
> => {
    try {
        if (oldAPI) {
            return await fetchDateChoosesOld(columnID.toString());
        }

        const res = await fetchDateChoosesNewAPI(session, columnID, onCriticalError);

        return (
            res?.Values?.map(item => ({
                label: item.Value,
                value: item.Value
            })) || []
        );
    } catch (e) {
        console.error('Error while fetching DateChooses list:', e);
        return [];
    }
};
